// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2uB1W","header":"PatientQuestionnaire_header__zDaVE","info":"PatientQuestionnaire_info__3bxCp"};